import { Injectable } from '@angular/core';
import * as pdfMakeModule from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

/** Descarga / vista previa de los formatos GA (definiciones de ga-forms.ts). */
@Injectable({ providedIn: 'root' })
export class GaPdfService {
  private get pdfMake(): any {
    const pm: any = (pdfMakeModule as any).default ?? pdfMakeModule;
    if (!pm.vfs || !Object.keys(pm.vfs).length) {
      pm.vfs = (pdfFonts as any).pdfMake?.vfs ?? (pdfFonts as any).default?.pdfMake?.vfs ?? (pdfFonts as any).vfs ?? pdfFonts;
    }
    return pm;
  }

  download(doc: any, fileName: string): void {
    this.pdfMake.createPdf(doc).download(`${fileName}.pdf`);
  }

  /** PDF en base64 (sin prefijo data:), para adjuntarlo a un correo. */
  base64(doc: any): Promise<string> {
    return new Promise(resolve => this.pdfMake.createPdf(doc).getBase64((b: string) => resolve(b)));
  }

  preview(doc: any): Promise<string> {
    return new Promise(resolve => this.pdfMake.createPdf(doc).getBlob((b: Blob) => resolve(URL.createObjectURL(b))));
  }
}
